const styles = theme => {
  return {
    root: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      flexWrap: 'wrap',
      color: '#16374F'
    },
    databoxContainer: {
      display: 'flex',
      justifyContent: 'center',
      [theme.breakpoints.down(1620)]: {
        width: '1020px',
        justifyContent: 'space-between'
      },
      [theme.breakpoints.down(1130)]: {
        width: '500px',
        flexDirection: 'column'
      },
      [theme.breakpoints.down(500)]: {
        width: '100%'
      }
    },
    dataRoot: {
      display: 'flex',
      [theme.breakpoints.down(1130)]: {
        width: '500px',
        flexDirection: 'column'
      },
      [theme.breakpoints.down(500)]: {
        width: '100%'
      }
    },
    dataContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    container: {
      width: '500px',
      backgroundColor: '#FFF',
      display: 'inherit',
      flexDirection: 'column',
      margin: '5px 5px 0 5px',
      padding: '10px 0',
      [theme.breakpoints.down(500)]: {
        width: '100%'
      }
    },
    subContainer: {
      display: 'flex',
      [theme.breakpoints.down('1620')]: {
        flexDirection: 'column'
      }
    },
    numberError: {
      fontSize: '12px',
      display: 'flex',
      width: '100%',
      justifyContent: 'center'
    },
    rightPanelRoot: {
      backgroundColor: '#F2F3F8',
      height: 'fit-content'
    },
    panelContainerRoot: {
      flexWrap: 'nowrap',
      flexDirection: 'column',
      justifyContent: 'unset'
    },
    popupContainerRoot: {
      flexDirection: 'row',
      justifyContent: 'center'
    },
    icon: {
      fontSize: '40px',
      '&:hover': { filter: 'brightness(1.5)' },
      cursor: 'pointer'
    },
    disablePointer: { cursor: 'unset', '&:hover': { filter: 'brightness(1)' } }
  };
};

export default styles;
